import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CONTACT } from "../../data/site";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { Toaster } from "sonner";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

export default function Layout() {
  return (
    <div className="min-h-screen bg-white text-ink font-body">
      <ScrollTop />
      <Header />
      <main><Outlet /></main>
      <Footer />
      <Toaster position="top-center" richColors />
      <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-button" aria-label="Chat on WhatsApp"
        className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-40 inline-flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full bg-[#128C7E] text-white shadow-lg shadow-black/20 transition-transform duration-300 hover:scale-105">
        <WhatsAppIcon className="h-7 w-7" />
      </a>
    </div>
  );
}
